export const MY_LOANS_SIDEBAR_TTL_MS = 5 * 60 * 1000;

export const ENCOMPASS_LOS_TYPE = "encompass" as const;
